import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { environment } from '../../../../environments/environment';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService); // Inject the service
  const accessToken = localStorageService.getToken();
  const router = inject(Router);

  const isApiUrl = req.url.startsWith(environment.API_BASE_URL);
  if (accessToken && isApiUrl) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
    });
  } else {
    console.warn('Token not added. Either token is missing or URL does not match API_BASE_URL.');
  }

  return next(req).pipe(
    // Handle errors here
    catchError(error => {
      if (error.status === 401) {
        localStorageService.clearAllStorage();
        router.navigate(['/']);
      }
      return throwError(() => error);
    })
  );
};
